import { sendGAEvent } from "."

export const sendAddToCartGAEvent = (eventName, dataSelected, cartData) => {
	// console.log("variantSelected:",dataSelected)
	try {
		const addedVariant = cartData?.lines?.edges?.find(item => item?.node?.merchandise?.id === dataSelected?.id)
		// console.log("item added:", addedVariant)
		const { cost, merchandise } = addedVariant?.node
		sendGAEvent(eventName, {
			currency: cost?.subtotalAmount?.currencyCode,
			value: cost?.subtotalAmount?.amount,
			items: [
				{
					item_id: dataSelected?.id,
					item_name: merchandise?.product?.title,
					affiliation: "Blackbough Swim",
					// coupon: "SUMMER_FUN",
					discount: parseFloat(cost?.compareAtAmountPerQuantity?.amount) - parseFloat(cost?.subtotalAmount?.amount),
					// index: 0,
					item_brand: "Blackbough Swim",
					item_category: "Apparel",
					item_category2: dataSelected?.title,
					// item_category3: "Shirts",
					// item_category4: "Crew",
					// item_category5: "Short sleeve",
					// item_list_id: "related_products",
					// item_list_name: "Related Products",
					item_variant: dataSelected?.id,
					// location_id: "ChIJIQBpAG2ahYAR_6128GcTUEo",
					price: parseFloat(cost?.subtotalAmount?.amount),
					quantity: 1
				},
			]
		})
	} catch (error) {
		console.error("something went wrong...", error);
	}
}
